// 动态载入所需要的语言包(按需加载)
export const dynamicImportLang = (i18n,locale ) => {
	return new Promise((resolve,reject) => {
		const { messages } = i18n;
		if(Object.keys(messages).includes(locale)) {
			resolve(true);
		} else {
			import(`@/i18n/lang/${locale}.json`).then( resp => {
				i18n.setLocaleMessage(locale,{
					...resp.default
				});
				resolve(true);
			}).catch(reject);
		}
	});
};


/**
 * 根据 设备宽度动态加载组件
 * @param{String} pcComponentPath pc组件的位置，相对于 src/components 目录
 * @param{String} mobileComponentPath 移动端组件位置 相对于 src/components 目录
 * @param{Number} deviceWidth 设备宽度
 */
export const dynamicImportComponentByDeviceWidth = (pcComponentPath,mobileComponentPath,deviceWidth = 700) => {
	if(!pcComponentPath) {
		return;
	}
	if(!mobileComponentPath) {
		return;
	}
	return new Promise((resolve,reject) => {
		const isPc = document.body.clientWidth >= deviceWidth;
		const dynamicComponentPath = isPc ? pcComponentPath : mobileComponentPath;
		import(`@/components${dynamicComponentPath}`).then( resp => {
			resolve(resp.default);
		}).catch(reject);
	});
};

/**
 * 根据 设备宽度动态加载组件
 * @param{String} pcComponentPath pc组件的位置，相对于 src/views 目录
 * @param{String} mobileComponentPath 移动端组件位置 相对于 src/views 目录
 * @param{Number} deviceWidth 设备宽度
 */
export const dynamicImportViewsByDeviceWidth = (pcComponentPath,mobileComponentPath,deviceWidth = 700) => {
	if(!pcComponentPath) {
		return;
	}
	if(!mobileComponentPath) {
		return;
	}
	return new Promise((resolve,reject) => {
		const isPc = document.body.clientWidth >= deviceWidth;
		const dynamicComponentPath = isPc ? pcComponentPath : mobileComponentPath;
		import(`@/views${dynamicComponentPath}`).then( resp => {
			resolve(resp.default);
		}).catch(reject);
	});
};
